import { CreateService, CRUDServiceInterface } from '@/services/service';
import { IssueEntity } from '@/entities/issue.entity';
import APIBuilder from '@quangphuc/frontend-api-builder';

export interface ResolveIssueEntity {
  issueId: number | string;
  message: string;
}

export interface SendThankIssueEntity {
  issueId: number | string;
  supporterId: number | string;
  gift: number | string;
  message: string;
}

export default class IssueService
  extends CreateService<IssueEntity>('issue')
  implements CRUDServiceInterface<IssueEntity>
{
  async resolve(resolveData: ResolveIssueEntity): Promise<IssueEntity> {
    const { data } = await APIBuilder.axios.post<IssueEntity>(
      `${this.store}/resolve`,
      resolveData,
    );
    return data;
  }

  async sendThank(resolveData: SendThankIssueEntity): Promise<IssueEntity> {
    const { data } = await APIBuilder.axios.post<IssueEntity>(
      `${this.store}/send-thank`,
      resolveData,
    );
    return data;
  }

  async getOne(
    id: number,
    join: string[] = [
      'resolveBy',
      'supporters',
      'staff',
      'type',
      'reactions.emoticon',
    ],
  ): Promise<IssueEntity> {
    this.apiBuilder.reset()
    return super.getOne(id, join);
  }
}
